/**
 * Created by luka on 01.03.2018.
 */
import {colors} from '../styles/colors';
import {
	CONFIRMED,
	CURRENT_CONFIRMED,
	CURRENT_PAUSE,
	CURRENT_PENDING,
	MISSED,
	PAUSE,
	PAUSE_CONFIRMED,
	PENDING,
	TOMORROW,
	CHEATED,
	TOMORROW_PAUSE,
	SUSPICIOUS,
} from './DayStates';

export function getTextColor(state, isSubtitle) {
	const activeColor = colors.white;
	const inactiveColor = colors.text_light;
	const inactivePassedColor = colors.text;

	const inactiveSuccessCollor = '#505050';
	switch (state) {
		case TOMORROW_PAUSE:
			return inactiveColor;
		case PAUSE:
			return inactiveColor;
		case TOMORROW:
			return inactiveColor;
		case MISSED:
			return colors.red;
		case CHEATED:
		case SUSPICIOUS:
			return inactivePassedColor;
		case CURRENT_PAUSE:
		case CURRENT_CONFIRMED:
			return activeColor;
		case CONFIRMED:
		case PAUSE_CONFIRMED:
			return inactiveSuccessCollor;
		case PENDING:
			return inactiveColor;
		case CURRENT_PENDING:
			return activeColor;
		default:
			return '';
	}
}



// WEBPACK FOOTER //
// ./src/overview/TextColorHelper.js